import styled from '@emotion/styled'

export const IconButtonHoverActions = styled.aside`
  opacity: 0;
`
